import { useMemo } from 'react'
import { useMatiApiClient } from './client'
import { useQuery as useQueryBase } from '@maui/react-query'
import { useLiveRef } from '../../utils/helpers'

export const useQueryYara = (options = {}) => {
  const { adapters, adapter: adapterName, ...queryOptions } = options
  const { data: rawData, ...result } = useQueryBase(queryOptions)
  const adapterRef = useLiveRef(adapters ? adapters[adapterName] : null)
  const data = useMemo(() => {
    if (rawData === undefined || adapterRef.current === undefined) { return }
    return adapterRef.current?.(rawData) || rawData
  }, [rawData, adapterRef])
  return { data, ...result }
}

const adapters = {
  default: (data) => data?.signatures.map(yara => yara.rule).join('\n\n') || 'No YARA rules available',
  raw: (data) => data,
}

export const useYaraQuery = (id, options = {}) => {
  const api = useMatiApiClient('yara')
  return useQueryYara({
    ...options,
    queryFn: () => api.getYara(id),
    queryKey: ['yara', id],
    adapters,
  })
}

export const useGetYaraDownload = (options = {}) => {
  const api = useMatiApiClient('yara')
  const { ids, ...restOptions } = options

  if (ids && !Array.isArray(ids)) {
    throw new Error('ids option must be an array')
  }

  const enabled = !!ids?.length

  return useQueryBase({
    queryFn: () => api.download(ids),
    queryKey: ['yara download', ids],
    ...restOptions,
    enabled: (restOptions.enabled ?? true) && enabled
  })
}
